import { List } from "immutable";
import { MobileBaseObject } from "./mobile-base-object";
import { Activity } from "./activity";

export interface IActor extends MobileBaseObject {
  name: string;
  type: string;
  description: string;
  comment: string;
  meta: string;
  dateKey: string;
  liveFlightID: string;
  modifiedBy: string;
  airportID: string;
  activities: Array<Activity>;
  etaTransfer: string;
  etaUpdated: string;
}


export class Actor extends MobileBaseObject implements IActor {
  public name: string;
  public type: string;
  public description: string;
  public comment: string;
  public meta: string;
  public dateKey: string;
  public liveFlightID: string;
  public modifiedBy: string;
  public airportID: string;
  public activities: Array<Activity>;
  public etaTransfer: string;
  public etaUpdated: string;


  public constructor(
    actor: Partial<IActor>
  ) {
    super();

    this.name = actor.name;
    this.type = actor.type;
    this.description = actor.description;
    this.comment = actor.comment;
    this.meta = actor.meta;
    this.dateKey = actor.dateKey;
    this.liveFlightID = actor.liveFlightID;
    this.modifiedBy = actor.modifiedBy;
    this.airportID = actor.airportID;
    this.activities = actor.activities;
    this.etaTransfer = actor.etaTransfer;
    this.etaUpdated = actor.etaUpdated;

    this.id = actor.id;
    this.version = actor.version;
    this.createdAt = actor.createdAt ? new Date(actor.createdAt) : actor.createdAt;
    this.updatedAt = actor.updatedAt ? new Date(actor.updatedAt) : actor.updatedAt;
    this.version = actor.version;
  }

  public get metaExpanded(): ActorMeta {
    return JSON.parse(this.meta) as ActorMeta;
  }
  public set metaExpanded(value: ActorMeta) {
    this.meta = JSON.stringify(value);
  }
}

export class ActorMeta {
  public Source: string;
  public Equipments: string;
  public Passenger: ImportFlightInformationFlightInformationPassenger;
  public ToBeBilled: boolean;
  public CancelledByApi: boolean;
  public CancelledByApiConfirmed: boolean;
  public CoDrivers: AssignmentCoDriver[];

  public get EquipmentsExpanded(): List<string> {
    return JSON.parse(this.Equipments) as List<string>;
  }
  public set EquipmentsExpanded(value: List<string>) {
    this.Equipments = JSON.stringify(value);
  }
}

export class ImportFlightInformationFlightInformationPassenger {
  public ChangeType: ImportFlightInformationFlightInformationPassengerChangeType;
  public LanguageAsString: string;
  public ChangeTypeSpecified: boolean;
  public Received: Date;
  public FirstName: string;
  public LastName: string;
  public Seat: string;
  public ConnectionFlight: string;
  public AssistanceChangedByKOO: boolean;
  public Assistances: ImportFlightInformationFlightInformationPassengerAssistance[];
}

export class ImportFlightInformationFlightInformationPassengerAssistance {
  public Type: string;
  public SubType: string;
  public Comment: string;
}

export enum ImportFlightInformationFlightInformationPassengerChangeType {
  ADD,
  UPDATE,
  DELETE
}

export class AssignmentCoDriver {
  public Name: string;
  public BusNumber: string;
  public UserMappingID: string;
  public ActorId: string;
}
